<div class="menu">
  <cs-tab
    class="tab"
    [tabs]="tabKeys"
    [selectedIndex]="tabIndex"
    padding="lg"
    [width]="'auto'"
    (tabChange)="onTabChanged($event)"
  ></cs-tab>
  <cs-sub-tab
    class="tab"
    [tabs]="subTabKeys"
    [selectedIndex]="subTabIndex"
    padding="lg"
    [width]="'full'"
    (tabChange)="onSubTabChanged($event)"
  ></cs-sub-tab>
</div>
@if (!dpLimitData && isLoading) {
  <div [appLoading]="true" class="wrapper"></div>
} @else {
  <div class="wrapper">
    @switch (tab) {
      @case ('deposit') {
        @if (dpLimitData.status === 'LimitReached') {
          <ng-container *ngTemplateOutlet="dpLimit"></ng-container>
        } @else {
          @switch (subTab) {
            @case ('web3Wallet') {
              <app-deposit-web3-wallet></app-deposit-web3-wallet>
            }
            @case ('transfer') {
              <app-deposit-transfer></app-deposit-transfer>
            }
            @case ('buyCrypto') {
              <app-deposit-crypto></app-deposit-crypto>
            }
          }
        }
      }
      @case ('withdraw') {
        @switch (subTab) {
          @case ('web3Wallet') {
            <app-withdraw-web3-wallet></app-withdraw-web3-wallet>
          }
          @case ('transfer') {
            <app-withdraw-transfer></app-withdraw-transfer>
          }
        }
      }
    }
  </div>
}

<ng-template #dpLimit>
  <div class="container">
    <div class="body-container">
      <div class="body">
        <span class="label">Limit reached</span>
        <span>You have hit your deposit limit, you will not be able to deposit until the timer below expires.</span>
        <app-countdown-limit
          [until]="dpLimitData.until"
          (countdownComplete)="onCountdownComplete()"
        ></app-countdown-limit>
      </div>
      <div class="btn">
        <cs-button label="Change Settings" color="primary" (buttonClick)="onSettings()"></cs-button>
      </div>
    </div>
  </div>
</ng-template>
